import { LucideCheck, LucideMapPin } from 'lucide-react';
import { useCallback, useMemo, useState } from 'react';
import { useLocations } from '~/shell/routes/resources/CcLocationsRoute';
import { Button } from '~/common/components/ui/button';
import { Dialog } from '@radix-ui/react-dialog';
import { DialogContent, DialogTitle } from '~/common/components/ui/dialog';
import { ScrollArea } from '~/common/components/ui/scroll-area';
import { useTranslation } from 'react-i18next';
import { cn } from '~/common/utils/styleUtil';

export function MobileShopLocationSelector({className}: Readonly<{className?: string}>) {
  const [open, setOpen] = useState(false);
  const { locations, ccId, setCcId } = useLocations();
  const { t } = useTranslation();

  const selectedLocation = useMemo(() => locations?.find(location => location.id === ccId), [ccId, locations]);

  const handleSelection = useCallback((locationId: number) => {
    if(locationId !== ccId){
      setCcId(locationId);
    }
    setOpen(false);
  }, [ccId, setCcId]);

  if (locations.length == 0) {
    return null;
  }

  return (
    <>
      <Button
        variant="ghost"
        size={'sm'}
        className={cn('justify-start desktop:text-secondary mr-0 px-0 h-12 desktop:h-auto desktop:px-2', className)}
        onClick={() => setOpen(true)}
      >
        <LucideMapPin className={'w-[24px] h-[24px] desktop:w-[18px] desktop:h-[18px]'} />
        <div className={'ml-2 desktop:ml-1 text-base desktop:text-sm '}>{selectedLocation?.text}</div>
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent showFullscreenOnMobile data-testid={'mobile-shop-location-dialog'}>
          <DialogTitle>{t('Prodega Standort')}</DialogTitle>
          <ScrollArea className="h-full pb-0">
            <div className={'flex flex-col'}>
              {locations?.map(location => {
                const isSelected = location.id === ccId;
                return (
                  <button type="button" key={location.id} onClick={() => handleSelection(location.id)} className={cn('text-left border-b py-3 flex items-center justify-between', isSelected && "font-bold text-primary-dark")}>
                    {location.text}
                    {isSelected && <LucideCheck/>}
                  </button>
                );
              })}
            </div>
          </ScrollArea>
        </DialogContent>
      </Dialog>
      <hr/>
    </>
  );
}
